import {
  DummyDriver,
  Kysely,
  SqliteAdapter,
  SqliteIntrospector,
  SqliteQueryCompiler,
} from 'kysely';

import { DB as TableDefinitions } from './schema-types';

// Use this to construct queries, like:
//
//     db.selectFrom('some_table').select(['one', 'two', 'three'])
export const db = new Kysely<TableDefinitions>({
  dialect: {
    createAdapter: () => new SqliteAdapter(),
    createDriver: () => new DummyDriver(),
    createIntrospector: (k: Kysely<unknown>) => new SqliteIntrospector(k),
    createQueryCompiler: () => new SqliteQueryCompiler(),
  },
});
